<app-widget-core [isClear]="isClear">

  <div class="widget-pie-chart">

    @if (title) {
      <div class="title">{{ title }}</div>
    }

    <div class="chart-wrap">

      @if (data) {

        <apx-chart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [dataLabels]="chartOptions.dataLabels!"
          [legend]="chartOptions.legend!"
          [labels]="chartOptions.labels!"
        ></apx-chart>

      } @else {

        <div class="no-data-chart">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </div>

      }

    </div>

    <ng-content select="[extra-content]"></ng-content>

  </div>

</app-widget-core> 
